import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders', {
        url: '/shared-folders',
        component: 'companySharingCenterSharedFolders',
        resolve: {sharedFolders},
    });
}

/** @ngInject */
function sharedFolders( companyId, SharedFoldersResource) {
    return SharedFoldersResource
        .getSharedFolders(companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/shared-folders.state.js